import * as $ from "jquery";
import * as BS from "bootstrap";

/** Dugmad u zaglavlju: filter, spisak, info. Na mobilnom je otvoren samo jedan panel. */
export class TopNavigation {
    private static filterShown = true;
    /** На широком екрану списак стоји отворен; на телефону би прекрио мапу. */
    private static listShown = window.innerWidth >= 992;

    public static setup(): void {
        $('#btnFilter').on('click', () => TopNavigation.toggle('filter'));
        $('#btnList').on('click', () => TopNavigation.toggle('list'));
        const info = new BS.Modal(document.getElementById('infoModal'));
        $('#btnInfo').on('click', () => info.show());
        TopNavigation.apply();
    }

    private static toggle(which: 'filter' | 'list'): void {
        const small = window.innerWidth < 992;
        if (which === 'filter') {
            TopNavigation.filterShown = !TopNavigation.filterShown;
            if (small && TopNavigation.filterShown) TopNavigation.listShown = false;
        } else {
            TopNavigation.listShown = !TopNavigation.listShown;
            if (small && TopNavigation.listShown) TopNavigation.filterShown = false;
        }
        TopNavigation.apply();
    }

    private static apply(): void {
        $('#mapFilter').toggle(TopNavigation.filterShown);
        $('#btnFilter').toggleClass('btn-light', TopNavigation.filterShown).toggleClass('btn-secondary', !TopNavigation.filterShown);
        $('#listPanel').toggle(TopNavigation.listShown);
        $('#btnList').toggleClass('btn-light', TopNavigation.listShown).toggleClass('btn-secondary', !TopNavigation.listShown);
    }
}
